/* src/app/views/dashboard/components/sidebar-nav/nav-sub-item/product-groups-sub-nav-item/product-groups-sub-nav-item.component.scss */
/*# sourceMappingURL=product-groups-sub-nav-item.component.css.map */
